import { NumerosALetras } from 'numero-a-letras';
import { Injectable } from '@angular/core';

import { AngularFirestore } from '@angular/fire/compat/firestore';
import { take } from 'rxjs/operators';
import * as moment from 'moment';
import { User } from '../COMERCIAL/MODULOS/user.interface';
import pdfMake from 'pdfmake/build/pdfmake';
import { PdfMakeWrapper } from 'pdfmake-wrapper';
import pdfFonts from 'pdfmake/build/vfs_fonts';
PdfMakeWrapper.setFonts(pdfFonts);

@Injectable({
  providedIn: 'root',
})
export class PdfService {
  products: any;
  price_one: any;
  price_two: any;
  user: User;
  corredor: any;

  constructor(private afs: AngularFirestore) {}

  formatterPrice(price: number, articulo: any) {
    let articleCurrency = articulo.articulo.currency;
    if (articleCurrency == 'EUR') {
      const formatterEuro = new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
      });
      let letter = formatterEuro.format(price);
      this.price_one = formatterEuro.format(price) + ' EUR';
      this.price_two = formatterEuro.format(price) + ' EUR';
      return letter.replace('$', '€');
    } else if (articleCurrency == 'USD') {
      const formatterDolar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      });
      // return formatterDolar.format(price)
      this.price_one = formatterDolar.format(price) + ' USD';
      this.price_two = formatterDolar.format(price) + ' USD';
    } else {
      const formatterPeso = new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
      });

      this.price_one = formatterPeso.format(price) + ' MXN';
      this.price_two = ' (00/100 MN)';
      // let prices = {
      //   price_one,
      //   price_two
      // }
      // return prices
    }
  }
  generatePdf(cliente: any, articulo: any) {
    if (articulo.estatus == 'incompleto')
      alert('Revisa que todo esté completo');
    else {
      let producto = articulo.commodity.producto;
      this.products = this.getProduct(producto);
      this.makePdf(cliente, articulo, cliente.uid_user);
    }
  }

  getProduct(name) {
    if (name == 'gold99' || name == 'Gold99') {
      return 99;
    } else if (name == 'elite99' || name == 'Elite99') {
      return 369;
    } else if (name == 'diamond99' || name == 'Diamond99') {
      return 189;
    } else if (name == 'imperial99' || name == 'Imperial99') {
      return 449;
    }
  }

  makePdf(cliente: any, articulo: any, uid_user: string) {
    // let newName: string = '';
    // let fullName = String(cliente.cliente.nombre + ' ' + cliente.cliente.apellido).split(' ');
    // for (let i = 0; i <= fullName.length - 1; i++) {
    //   newName += fullName[i].charAt(0).toUpperCase() + fullName[i].slice(1) + ' '
    // }

    let dirCustomer;
    let dirArticle;
    if (
      cliente.cliente.no_interior !== null &&
      cliente.cliente.no_interior !== ''
    ) {
      dirCustomer =
        String(cliente.cliente.no_exterior).toUpperCase() +
        ' int ' +
        String(cliente.cliente.no_interior).toUpperCase();
    } else {
      dirCustomer = String(cliente.cliente.no_exterior).toUpperCase();
    }
    if (
      articulo.articulo.no_interior !== null &&
      articulo.articulo.no_interior !== ''
    ) {
      dirArticle =
        String(articulo.articulo.no_exterior).toUpperCase() +
        ' int ' +
        String(articulo.articulo.no_interior).toUpperCase();
    } else {
      dirArticle = String(articulo.articulo.no_exterior).toUpperCase();
    }

    this.afs
      .collection('USERS')
      .doc(uid_user)
      .valueChanges()
      .pipe(take(1))
      .toPromise()
      .then(async (corredor: any) => {
        this.corredor = corredor.displayName;
        let dias: string;
        let price = articulo.articulo.precio;
        this.formatterPrice(price, articulo);
        let newPriceToLetter: String = NumerosALetras(price);
        let currencyToLetter: string;
        dias = this.products;
        let articleCurrency = articulo.articulo.currency;
        if (articleCurrency == 'EUR') currencyToLetter = 'Euros';
        if (articleCurrency == 'USD') currencyToLetter = 'Dolares';
        if (articleCurrency == 'MXN') currencyToLetter = 'Pesos';

        const documentDefinition = {
          info: {
            title: `Producto ${String(
              articulo.commodity.producto
            ).toUpperCase()}`,
            author: 'Net99',
          },
          // pageSize: {
          //   width: 595.28,
          //   height: 1000
          // },
          pageSize: 'LETTER',
          pageMargins: [35, 20, 35, 0],
          content: [
            {
              bold: true,
              text: 'Definiciones\n\n',
            },
            {
              alignment: 'justify',
              columns: [
                {
                  fontSize: 7.8,
                  text:
                    'Se le denomina cliente a ' +
                    String(cliente.cliente.nombre).toUpperCase() +
                    ' ' +
                    String(cliente.cliente.apellido).toUpperCase() +
                    ' y Net99 a Juan José Márquez Villanueva. Artículo: Inmueble que autoriza el titular de éste mismo y/o representante del inmueble material del presente convenio que Net99 toma en comercialización con carácter de exclusiva.\n Conforme a las siguientes definiciones, declaraciones, objeto, subsecuentes términos, condiciones y cláusulas.\n\n' +
                    'DECLARACIONES\n PRIMERO.- Declara el cliente:\n A) Ser mexicano, mayor de edad, con plena capacidad para contratar y obligarse en los términos del presente instrumento. Lo cual lo acredita con la copia de su identificación oficial como (anexo1), y a la firma del presente convenio se identifica con ' +
                    cliente.identificacion +
                    ' número ' +
                    cliente.cliente.identificacion +
                    '.\nB) Que señala como domicilio para cualquier efecto legal en ' +
                    'calle ' +
                    String(cliente.cliente.calle).toUpperCase() +
                    ', #' +
                    dirCustomer +
                    ', colonia ' +
                    String(cliente.cliente.colonia).toUpperCase() +
                    ', código postal ' +
                    cliente.cliente.cp +
                    ', ciudad ' +
                    String(cliente.cliente.ciudad).toUpperCase() +
                    ', estado ' +
                    String(cliente.cliente.estado).toUpperCase() +
                    ', país ' +
                    String(cliente.cliente.pais).toUpperCase() +
                    ' mismo que señala para oír y recibir todo tipo de notificaciones relacionadas con el presente convenio. Teléfono +52 ' +
                    cliente.cliente.telefono +
                    '\nC) Que es legítimo titular, dueño y apoderado. Que cumple con todos lo requisitos y comprobación jurídica que lo demuestre del artículo ubicado en calle: ' +
                    String(articulo.articulo.calle).toUpperCase() +
                    ', #' +
                    dirArticle +
                    ', colonia ' +
                    String(articulo.articulo.colonia).toUpperCase() +
                    ', código postal ' +
                    articulo.articulo.cp +
                    ', ciudad ' +
                    String(articulo.articulo.ciudad).toUpperCase() +
                    ', estado ' +
                    String(articulo.articulo.estado).toUpperCase() +
                    ', país ' +
                    String(articulo.articulo.pais).toUpperCase() +
                    ',  entre las calles ' +
                    String(articulo.articulo.entre_calle1).toUpperCase() +
                    ' y ' +
                    String(articulo.articulo.entre_calle2).toUpperCase() +
                    '\nD) Haber verificado escrituras del artículo antes descrito para comprobar su titularidad del mismo. Así como también contar con los documentos y certificados vigentes que hagan constar la libertad de gravámenes del artículo.\nE) Que es su interés contratar los servicios de Net99 profesional en el ramo.\nF) Que Net99 puede disponer del artículo para su exhibición e intermediación de éste en absoluta exclusiva y que es su deseo que Net99 promueva en arrendamiento y/o compraventa del mismo en absoluta exclusiva mediante un período de ' +
                    dias +
                    ' días.\n SEGUNDO.- Declara Net99:\nA) Que es una empresa jurídica y socialmente comprometida, que opera con total transparencia y con toda legalidad; que es de nacionalidad mexicana, mayor de edad, con plena capacidad para contratar y obligarse en los términos y condiciones del presente instrumento.\nB) Que tiene su domicilio en Calle Alud 833 int 207, Colonia Jardines del Moral, Código Postal 37160 León, Guanajuato, México.\nC) Que cuenta con experiencia probada y calificada. Así como con los medios oportunos y recursos suficientes para realizas tales funciones.\nD) Que cuenta con los elementos e instrumentos necesarios para desempeñar su actividad de intermediario mercante, por lo que el cliente no tienen responsabilidad alguna en el desarrollo y ejecución de actividades de Net99.\n\nOBJETO\nEl cliente le confiere a Net99 la comisión mercantil, en términos del articulo 273 del código de comercio, que consiste en lograr la venta y/o arrendamiento y por consecuencia la celebración del contrato para formalizar las operación de compraventa y/o arrendamiento del artículo; material del presente convenio.\n\nTÉRMINOS\n' +
                    '•Producto Asignado: ' +
                    String(articulo.commodity.producto).toUpperCase() +
                    '\n•Precio de ' +
                    String(articulo.tipo.tipo).toUpperCase() +
                    ' del articulo: ' +
                    this.price_one +
                    ` (${String(newPriceToLetter).toUpperCase()} ${String(
                      currencyToLetter
                    ).toUpperCase()})` +
                    '\n •ID del artículo: ' +
                    articulo.id_articulo +
                    '\n •Fecha de inicio del convenio: ' +
                    moment(articulo.commodity.start).format('DD-MM-YYYY') +
                    ' a las ' +
                    moment(articulo.commodity.start).format('HH:MM:SS') +
                    '\n•Vigencia: La vigencia del presente convenio es por ' +
                    dias +
                    ' días a partir del fecha de inicio.\n•Pago por servicio: La forma de pago por servicio será pagada por el cliente a Net99 a la firma del contrato de compraventa y/o arrendamiento. En caso de compraventa será por el 5% (CINCO POR CIENTO) sobre el monto total del precio de venta y en el caso de arrendamiento el pago de los honorarios por servicio será el equivalente a un mes de arrendamiento del artículo es decir la cantidad de ' +
                    `${String(newPriceToLetter).toUpperCase()} ${String(
                      currencyToLetter
                    ).toUpperCase()}` +
                    ' más I.V.A.',
                },

                {
                  fontSize: 7.8,
                  text: 'Beneficios\n Diamond99Product:\n1. Portales de promoción digital\n2. Pendones Zonificados\n3. Adaptación de lonas sobre el artículo\n4. Manejo de #PriorityDiamon99Wallet\n5. Prioridad al 77% en actividad ejecutiva aplicable\n6. 58% de prioridad en la difusión y periodos de publicación mediante medios generales, particulares y propios digitales, emisión, difusión, distribución de panfletos, difusión en revistas, periódicos y folletos a identidad total de net noventa y nueve.\n7. Producción de fotografía mediante cámara profesional de gama estándar.\n8. Solicitud para #AccessClear\n9. Personalización y creación de contenido gráfico especial y asignación particular.\n\nGold99Product:\n1. Adaptación de lonas sobre el artículo\n2. Manejo de #Gold99Wallet\n3. Prioridad al 51% en actividad ejecutiva aplicable\n4. 29% de prioridad en la difusión y periodos de publicación mediante medios generales, particulares y propios digitales a identidad total de net noventa y nueve\n5. Producción de fotografía mediante cámara profesional de gama estándar\n\nExclusive99Product:\n1. Adaptación de lonas sobre el artículo\n2. Manejo de #ExclusiveWallet\n3. Prioridad al 11% en actividad ejecutiva aplicable\n4. 5% de prioridad en la difusión y periodos de publicación mediante medios generales, particulares y propios digitales a identidad total de net noventa y nueve\n\nFree99Product:\n1. Manejo de #GeneralWallet\n2. Prioridad al 5% en actividad ejecutiva aplicable\n3. 1% de prioridad en la difusión y periodos de publicación mediante medios generales, particulares y propios digitales a identidad total de net noventa y nueve\n\n• Alcances 1: Net99 se limita a la gestión de prospectos para el arrendamiento y/o compraventa del artículo material del presente convenio.\n• Alcances 1.1: Net99 queda exento de toda responsabilidad legal y conductas realizadas bajo dolo o mala fe por el cliente y/o prospecto(s). Así como al contenido del artículo; datos,  mobiliario, cualquier tipo de robo, siniestro, fallas, y/o reparaciones relacionadas a éste.\n• Alcances 1.2: El cliente es responsable de toda actividad legal, comercial y financiera hacia los prospectos de Net99 en el procedimiento de las operaciones de arrendamiento de este inmueble, ya que da por hecho ser legítimo titular del artículo descrito en el presente convenio, haber verificado documentos y/o certificados que le acrediten la titularidad del artículo material del presente convenio. Así mismo el cliente declara y acepta que el artículo está libre de gravámenes, adeudos y en total regularidad jurídica y financiera. Así mismo el cliente se responsabiliza de cualquier acto o procedimiento que pudiera traerle daños o conflictos al futuro comprador prospecto de Net99 a razón de lo antes mencionado. Ya que Net99 se limita a la gestión e intermediación con terceros y prospectos para el arrendamiento y/o compraventa del presente articulo. Es decir, Net99 mostrará de manera física o virtual el artículo a sus prospectos con la única finalidad de concretar la colocación del articulo para que el cliente pueda realizar la venta y/o arrendamiento del articulo.',
                },
              ],
            },

            '\n\n',
            {
              table: {
                widths: [100, 415],
                heights: [10, 10],
                body: [
                  [
                    [
                      {
                        table: {
                          widths: [16, 40, 16],
                          heights: [5, 5, 5],
                          body: [
                            [' ', ' ', ' '],
                            ['', 'Cliente', ''],
                            [' ', ' ', ' '],
                          ],
                        },
                        layout: 'noBorders',
                      },
                    ],
                    '',
                  ],
                ],
              },
            },

            '\n\n ',

            {
              bold: true,
              text: 'Condiciones\n\n',
            },
            {
              alignment: 'justify',
              columns: [
                {
                  fontSize: 7.8,
                  text:
                    '• El cliente no podrá tener contacto por ningún motivo de manera directa con los prospectos de Net99 para formalizar el arrendamiento y/o compraventa del presente artículo. Aún y cuando sea iniciativa del prospecto de Net99. Siendo el caso y los prospectos vengan por conducto del cliente, por terceros y/o cualquier otro conducto; el cliente se obliga a facilitar la información que corresponda de los prospectos interesados en el artículo a Net99, para que éste haga efectivos sus labores, conservando el vigor del presente convenio.\n\n' +
                    '• Suspensión del convenio 1: El cliente no podrá suspender el presente convenio en exclusiva hasta dentro de un período de ' +
                    dias +
                    ' días. Ya sea por vigencia del presente convenio y que no incumplan los términos y condiciones del presente convenio; la suspensión del vigente convenio podrá ser realizada una vez terminado el periodo de exclusiva a solicitud del cliente de manera explicita y escrita por el cliente, y esta suspensión tendrá que ser aprobada por Net99 mediante el formato o documento que acredite el acto, de lo contrario el presente convenio se auto-renovará de manera mensual por tiempo indefinido. Y todas sus declaraciones, términos y condiciones no perderán vigor alguno.\n' +
                    '• Suspensión del convenio 1.1: El cliente no podrá suspender el presente convenio cuando haya operaciones de compraventa y/o arrendamiento avanzadas con los prospectos por conducto de Net99 del cliente y/o de terceros. Aún así ya terminado el periodo de exclusividad mencionado en las declaraciones, términos y condiciones del presente convenio\n' +
                    '• Suspensión del convenio 1.2: El cliente no podrá suspender el convenio por ningún motivo para tomar posesión de los prospectos propios, de terceros o de Net99 y dar continuidad al arrendamiento y/o compraventa del artículo. De ser sorprendido pagará a Net99 el equivalente a lo mencionado en el termino ‘pago por servicio’ conforme al caso de arrendamiento o bien compraventa y en ambos casos, es decir compraventa y/o arrendamiento. Si fuera el caso.\n' +
                    '• Suspensión del convenio 1.3: Net99 se reserva el derecho de suspender temporal o definitivamente sin previo aviso el presente convenio. En caso de que el cliente realice actos que atenten en contra de sus declaraciones o vaya en contra de todo acto jurídico establecido por las autoridades competentes, o incluso por no respetar los términos y condiciones del presente convenio y esto no le librará de sus obligaciones en el presente convenio; es decir el pago por servicio a Net99 en caso de incumplimiento, dolo o mala fe.\n' +
                    '• Suspensión del convenio 1.4 : En caso de que el cliente quiera realizar la suspensión del vigente convenio dentro del período de exclusiva mencionado en las declaraciones, términos y condiciones del presente convenio Net99 se hará acreedor a una sanción hacia el cliente por el monto establecido en el término ‘pago por servicio’ y será aplicable en todos los casos posibles; es decir en caso de arrendamiento, en caso de compraventa o ambos, arrendamiento y/o compraventa.\n' +
                    '• Promoción 1: Net99 registrará el artículo para reforzar la gestión interna de prospectos para la compraventa y/o arrendamiento del artícul en los medios físicos y virtuales que considere necesarios.\n' +
                    '• Promoción 1.1: Net99 promoverá el artículo internacionalmente en caso de ser necesario.\n' +
                    '• Net99 se reserva el derecho de reemplazar o cambiar sin previo aviso al corredor asignado, que representa de manera limitada la gestión con prospectos, registros, procesos y por ningún motivo el corredor asignado que representa la gestión de manera limitada para este artículo podrá recibir el pago del cliente, haciendo referencia explicita al pago mencionado en el termino ‘pago por servicio’, de lo contrario Net99 no reconocerá este pago, ya que infringe el presente convenio. Y el cliente no quedará libre de adeudo, hasta haberlo realizado de manera correcta y directa a Net99 mediante la modalidad y los medios que Net99 considere adecuados para que el cliente pueda realizar su pago por servicio a Net99.\n' +
                    '• Cobro por servicio 1: Se aplicará el cobro por servicio al cliente, bajo lo estipulado en el término ‘pago por servicio’ una vez que Net99 haya concretado la compraventa y/o arrendamiento del artículo.\n',
                },

                {
                  fontSize: 7.8,
                  text:
                    '• Cobro por servicio 1.1: Una vez que el cliente concrete por conducto de Net99 o bien por su propio conducto el arrendamiento y/o compraventa del articulo mencionado en el presente convenio, el cliente realizará el pago por servicio a Net99 de acuerdo a lo estipulado en el término ‘pago por servicio’ de este vigente convenio. Una vez concluyendo las firmas del respectivo contrato de arrendamiento y/o compraventa del artículo, material del presidente convenio.\n' +
                    '• Cobro por servicio 1.2: Una vez concluido el arrendamiento y/o compraventa del artículo por conducto de Net99 o bien por conducto del cliente, el pago podrá ser realizado por transferencia electrónica, cheque certificado o bien pago directo en el domicilio de Net99 mencionado en el vigente convenio.\n' +
                    '• Cobro por servicio 1.3: El cliente tendrá como máximo 3 días hábiles posteriores a la firma del contrato de arrendamiento y/o compraventa del artículo, materia del presente convenio, para generar el pago por servicio a Net99, una vez concluida la firma del contrato de compraventa y/o arrendamiento del articulo mencionado el presente convenio.\n' +
                    '• Cobro por servicio 1.4: Ya concluido el arrendamiento y/o compraventa del presente artículo, el cliente tendrá como máximo 3 días hábiles para generar el pago por servicio a Net99 mencionado el los términos del presente convenio. Si el cliente no genera el pago por servicio a Net99 dentro de los primeros 3 días hábiles posteriores al cierre de la compraventa y/o arrendamiento del presente convenio; Net99 se hará acreedor de un interés moratorio por el 1.5% diario aplicado al cliente y calculado sobre el monto total del pago por servicio mencionado en el presente convenio en el termino de ‘pago por servicio’ para todo caso, ya sea en compraventa, arrendamiento o bien en ambos casos, es decir compraventa y/o arrendamiento.\n' +
                    '• Cobro por servicio 1.5: Una vez concluido el arrendamiento y/o compraventa del artículo mencionado en el presente convenio por conducto de Net99 o bien del cliente y el cliente realizase el pago por servicio mencionado en los términos del presente convenio como ‘pago por servicio’ a otra persona que no sea Net99, este pago no será válido para Net99 y mucho menos Net99 se responsabilizará por el mismo, ya que en caso fortuito el cliente generará el pago por servicio bajo los términos y condiciones del presente convenio a Net99.\n' +
                    '• Anticipos 1: En caso de que alguno de los prospectos genere anticipos al cliente por conducto de Net99; Net99 tomará como retenido dicho anticipo para brindar garantía y seguridad al prospecto y así mismo al cliente ante el arrendamiento y/o compraventa del articulo mencionado en el presente convenio.\n' +
                    '• Anticipos 1.1: En caso de desistimiento por alguno de los prospectos que ya haya efectuado anticipos a Net99 y este desistimiento por parte del prospecto llegará a ser por algún incumplimiento legal, financiero o personal del cliente. Net99 hará la devolución del 100% (cien por ciento) del anticipo al prospecto que haya generado anticipos y Net99 se hará acreedor a una penalización hacia el cliente por el monto total del anticipo que el prospecto haya generado en calidad de anticipo a Net99. (esto podrá ser verificado por el cliente y demostrado al cliente mediante la póliza de anticipo que Net99 entregue al prospecto debidamente firmada por el prospecto y aprobada por Net99; o bien por algún otro medio o forma que resulten adecuados para demostrarlo. Lo antes mencionado será aplicable en todo caso ya sea de compraventa, arrendamiento o bien ambas, es decir de arrendamiento y/o compraventa.\n' +
                    '• Anticipos 1.2: Si el cliente por conducto de Net99 llegará a recibir anticipos por alguno de los prospectos. Una vez finalizada la operación de arrendamiento y/o compraventa del artículo mencionado en el presente convenio y en las condiciones ‘anticipos 1’ y ‘anticipos 1.1’ mencionados en presente convenio; Net99 tomará dicho anticipo como parte del pago por servicio que adeuda el cliente; mencionado en el término ‘pago por servicio’ del presente convenio. Sí dicho anticipo mencionado en el presente convenio y en las condiciones ‘anticipos 1’ y ‘anticipos 1.1’ del presente convenio, si dicho anticipo retenido por Net99 no llagará a cubrir el pago por servicio del cliente mencionado en los términos y condiciones del presente convenio; el cliente pagará a Net99 la diferencia o el total del adeudo pendiente bajo lo predispuesto en las declaraciones, términos y condiciones del presente convenio.',
                },
              ],
            },
            '\n',
            {
              table: {
                widths: [100, 415],
                heights: [10, 10],
                body: [
                  [
                    [
                      {
                        table: {
                          widths: [16, 40, 16],
                          heights: [5, 5, 5],
                          body: [
                            [' ', ' ', ' '],
                            ['', 'Cliente', ''],
                            [' ', ' ', ' '],
                          ],
                        },
                        layout: 'noBorders',
                      },
                    ],
                    '',
                  ],
                ],
              },
            },
            '\n\n\n',

            {
              bold: true,
              text: 'CLÁUSULAS\n\n',
            },
            {
              alignment: 'justify',
              columns: [
                {
                  fontSize: 7.8,
                  text:
                    '• Cláusula primera.- El contenido absoluto de este convenio se está respaldado por las leyes de los Estados Unidos Mexicanos. El cliente se somete a la jurisdicción de los tribunales competentes ubicados en la ciudad de León, Guanajuato, México. Con renuncia expresa a cualquier fuero y/o jurisdicción.\n' +
                    '• Cláusula segunda.- El cliente se obliga al cumplimiento y acepta expresamente y por firmado en 2(dos) tantos las definiciones, cláusulas, declaraciones, objeto del presente convenio.',
                },

                {},
              ],
            },
            {
              bold: true,
              text: '\nUsted no copiará ni adaptará el contenido de este convenio desarrollado por Net99.',
            },
            '\n\n\n',
            {
              table: {
                widths: [80, 12, 414],
                heights: [42, 42, 42],
                body: [
                  [
                    {
                      colSpan: 2,
                      rowSpan: 2,
                      alignment: 'center',
                      text: `


                  Cliente


                    `,
                    },
                    '',
                    {
                      alignment: 'center',
                      fontSize: 10,
                      text: 'CON LA PRESENTE FIRMA EXPRESO MI CONSENTIMIENTO Y CONFORMIDAD CON LOS TÉRMINOS Y CONDICIONES COMPRENDIDOS EN LOS DOCUMENTOS CONTENIDOS EN LOS PÁRRAFOS ANTERIORES',
                    },
                  ],
                  ['', '', ''],
                ],
              },
            },
            '\n',

            {
              table: {
                widths: [100, 415],
                heights: [10, 10],
                body: [
                  [
                    [
                      {
                        table: {
                          widths: [1, 70, 1],
                          heights: [5, 5, 5],
                          body: [
                            [' ', ' ', ' '],
                            ['', String(this.corredor).toUpperCase(), ''],
                            [' ', ' ', ' '],
                          ],
                        },
                        layout: 'noBorders',
                        fontSize: 10,
                        alignment: 'center',
                      },
                    ],
                    '',
                  ],
                ],
              },
            },

            '\n',
            {
              table: {
                widths: [100, 415],
                heights: [50, 50],
                body: [
                  [
                    [
                      {
                        table: {
                          widths: [16, 40, 16],
                          heights: [19, 19, 19],
                          body: [
                            [' ', ' ', ' '],
                            ['', 'Net99', ''],
                            [' ', ' ', ' '],
                          ],
                        },
                        layout: 'noBorders',
                        alignment: 'center',
                      },
                    ],
                    '',
                  ],
                ],
              },
            },

            // {
            //   bold: true,
            //   alignment: 'center',
            //   columns: [
            //     {
            //       fontSize: 11,
            //       text: 'Firma Net99'
            //     },
            //     {
            //       fontSize: 11,
            //       text: 'Frima Corredor Asignado'
            //     },
            //     {
            //       fontSize: 11,
            //       text: 'Nombre y Firma del Cliente'
            //     }
            //   ]

            // }, {
            //   bold: true,
            //   alignment: 'center',
            //   columns: [

            //     {
            //       fontSize: 10,
            //       text: '(Juan José Márquez Villanueva)'
            //     },
            //     {
            //       fontSize: 10,
            //       text: '(' + cliente.cliente.adicional_nombre + ' ' + cliente.cliente.adicional_apellido + ')'
            //     },
            //     {
            //       fontSize: 10,
            //       text: '(' + cliente.cliente.nombre + ' ' + cliente.cliente.apellido + ')'
            //     }
            //   ]

            // }
          ],

          defaultStyle: {
            columnGap: 20,
          },
        };
        pdfMake.createPdf(documentDefinition).open();
      });
  }
}
